let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("lJJQ8")]).then(() => parcelRequire('iDTLl'));